import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../assets/images/welcomeImage.png'


const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 welcome-lms-courses-box" }
const _hoisted_2 = { class: "card-body ps-15 pe-15 ps-sm-20 pe-sm-20 ps-md-25 pe-md-25 ps-lg-30 pe-lg-30 ps-xl-40 pe-xl-40 letter-spacing" }
const _hoisted_3 = { class: "row align-items-center" }
const _hoisted_4 = { class: "col-xxl-7" }
const _hoisted_5 = { class: "content" }
const _hoisted_6 = {
  class: "d-block fw-bold mb-5 text-white",
  id: "current-date"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h2", { class: "fw-semibold mb-8 text-white" }, [
  /*#__PURE__*/_createTextVNode(" Content de vous revoir "),
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-white" })
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "fs-md-15 fs-lg-16 text-white" }, " Nous prenons en charge la gestion complete de votre backoffice ", -1)
const _hoisted_9 = { class: "row list justify-content-center" }
const _hoisted_10 = { class: "col-lg-3 col-6 col-sm-3" }
const _hoisted_11 = { class: "p-15 mt-15 bg-f2f1f9" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "d-block mb-6 fw-medium text-black-emphasis fs-13 text-uppercase" }, " ARTICLE ", -1)
const _hoisted_13 = { class: "mb-0 fw-black text-primary" }
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div class=\"col-lg-3 col-6 col-sm-3\"><div class=\"p-15 mt-15 bg-faf7f7\"><span class=\"d-block mb-6 fw-medium text-black-emphasis fs-13 text-uppercase\"> BLOGS </span><h5 class=\"mb-0 fw-black text-success\"> 0 </h5></div></div><div class=\"col-lg-3 col-6 col-sm-3\"><div class=\"p-15 mt-15 bg-ecf3f2\"><span class=\"d-block mb-6 fw-medium text-black-emphasis fs-13 text-uppercase\"> PROJETS </span><h5 class=\"mb-0 fw-black text-success\"> 0 </h5></div></div><div class=\"col-lg-3 col-6 col-sm-3\"><div class=\"p-15 mt-15 bg-f3f7f9\"><span class=\"d-block mb-6 fw-medium text-black-emphasis fs-13 text-uppercase\"> BLOGS </span><h5 class=\"mb-0 fw-black text-success\"> 0 </h5></div></div>", 3)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "col-xxl-5 text-center text-xxl-end mt-15 mt-md-0" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "main-image",
    alt: "welcome-image"
  })
], -1)
const _hoisted_18 = { class: "col-md-3" }
const _hoisted_19 = { class: "card bg-light-primary" }
const _hoisted_20 = { class: "card-body" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h5", { class: "card-title text-bold" }, "Expiration", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", { class: "card-text mb-1" }, "La date d'expiration de l'abonnement est : 22-09-2026", -1)
const _hoisted_23 = { class: "badge bg-primary text-white fs-14" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.formattedDate), 1),
              _hoisted_7,
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _createElementVNode("h5", _hoisted_13, _toDisplayString(_ctx.totalActualites ? _ctx.totalActualites : 0), 1)
                  ])
                ]),
                _hoisted_14
              ])
            ])
          ]),
          _hoisted_17
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _hoisted_22,
          _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.daysLeftMessage), 1)
        ])
      ])
    ])
  ], 64))
}